export const getBlogNav = async (locale: string) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/items/blog_categories_translations?fields=name&filter={"languages_code" : {"_eq" : "${locale}"}}`,
      {
        cache: 'no-store',
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data.data;
    }
    return null;
  } catch (error) {
    console.log(error);
  }
};
